import Button from '@components/atoms/button/button';
import Spinner from '@components/atoms/spinner/spinner';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import styles from '../index.module.scss';

interface DeleteAccountButtonProps {
  onClick: () => void;
  isDeleting: boolean;
  isDeleteConfirm: boolean;
}

const DeleteAccountButton: React.FC<DeleteAccountButtonProps> = ({ onClick, isDeleting, isDeleteConfirm }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.deleteAccount__cta}>
      <Button
        onClick={onClick}
        disabled={!isDeleteConfirm || isDeleting}
        size="large"
        disableDefaultStyling={true}
        className={clsx(
          {
            'vc-btn--destructive': isDeleteConfirm,
            'vc-btn--secondary': !isDeleteConfirm,
          },
          'vc-btn',
          'vc-btn--large',
          'vc-btn--full',
          'vc-btn--notfull--md-up',
          styles.deleteAccount__cta__button,
        )}
      >
        {isDeleting ? (
          <>
            <Spinner className={styles.deleteAccount__cta__button__loading} />
            {t('ACCOUNT_DELETION_CTA_DELETE_LOADING')}
          </>
        ) : (
          t('ACCOUNT_DELETION_CTA_DELETE')
        )}
      </Button>
    </div>
  );
};

export default DeleteAccountButton;
